(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('CompanySubscriptionStatusSearch', CompanySubscriptionStatusSearch);

    CompanySubscriptionStatusSearch.$inject = ['$resource'];

    function CompanySubscriptionStatusSearch($resource) {
        var resourceUrl = 'api/_search/company-subscription-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
